// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1thW-","select":"Header_select__3i4fs","clinic":"Header_clinic__1q7JK"};